// The page's words in the page's own language (unify-ui ship 3). Two halves, composed: the
// package's shared table (leaves two or more tools hold with the same words) under this tool's
// own table — apps/<tool>/test/tables.test.js holds the composed table to English's key set,
// kinds and placeholders, and Thai is today's wording, character for character (ruling R18).
// ja, zh-CN and zh-TW are machine-written and unread (ruling G4).
import { pickTable, compose } from '@3dp/ui/i18n';
import { SHARED_EN } from '@3dp/ui/strings/en';
import { SHARED_TH } from '@3dp/ui/strings/th';
import { SHARED_JA } from '@3dp/ui/strings/ja';
import { SHARED_ZH_CN } from '@3dp/ui/strings/zh-cn';
import { SHARED_ZH_TW } from '@3dp/ui/strings/zh-tw';
import en from './strings/en.js';
import th from './strings/th.js';
import ja from './strings/ja.js';
import zhcn from './strings/zh-cn.js';
import zhtw from './strings/zh-tw.js';
export const S = pickTable({
  en: compose(SHARED_EN, en),
  th: compose(SHARED_TH, th),
  ja: compose(SHARED_JA, ja),
  'zh-cn': compose(SHARED_ZH_CN, zhcn),
  'zh-tw': compose(SHARED_ZH_TW, zhtw),
});
